import { QUESTIONNAIRE_ANSWER_TYPES } from './questionnaire.enums';

const HIGH_MEDIUM_LOW = ['High', 'Medium', 'Low'];

export const SALES_INDUSTRY_PROFESSIONAL_QUESTIONS = [
  {
    key: 'Q1',
    number: 1,
    question: 'What line of business were you primarily engaged in?',
    type: QUESTIONNAIRE_ANSWER_TYPES.DROPDOWN,
    options: [
      'Banking & Insurance',
      'FMCGs',
      'Service Selling (Airlines & Hospitality)',
      'Luxury (Cars)',
      'Real Estate',
      'Digital & Social Media',
      'Other (Please specify)',
    ],
    is_required: true,
  },
  {
    key: 'Q2',
    number: 2,
    question: 'What was your monthly sales target value?',
    type: QUESTIONNAIRE_ANSWER_TYPES.DROPDOWN,
    options: [
      'Below 200K',
      '200K – 500K',
      '500K – 1Mn',
      '1Mn – 10Mn',
      '10Mn – 50Mn',
      '50Mn – 100Mn',
      'Above 100Mn',
    ],
    is_required: true,
  },
  {
    key: 'Q3',
    number: 3,
    question: 'How often did you achieve your target?',
    type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
    options: ['Always', 'Often', 'Sometimes', 'Rarely'],
    is_required: true,
  },
  {
    key: 'Q4',
    number: 4,
    question: 'Do you have experience in insurance sales?',
    type: QUESTIONNAIRE_ANSWER_TYPES.BOOLEAN,
    is_required: true,
  },
  {
    key: 'Q5',
    number: 5,
    question:
      'If yes, how many years of insurance sales experience do you have?',
    type: QUESTIONNAIRE_ANSWER_TYPES.NUMBER,
    placeholder: 'Enter years',
    is_required: true,
    depends_on: { key: 'Q4', value: true },
    min: 0,
    max: 70,
    max_digits: 2,
    
  },
  // Source question 6 asks for a count and the names together. Split in two so
  // each answer keeps its own type. Pending confirmation from the JI team.
  {
    key: 'Q6A',
    number: 6,
    question:
      'How many insurance companies have you worked for in the last 5 years?',
    type: QUESTIONNAIRE_ANSWER_TYPES.NUMBER,
    placeholder: 'Number of Companies',
    is_required: true,
    min: 0,
    max: 99,
    max_digits: 2,
  },
  {
    key: 'Q6B',
    number: 6,
    question: 'Please name them.',
    type: QUESTIONNAIRE_ANSWER_TYPES.TEXTAREA,
    placeholder: 'Company Names',
    is_required: true,
  },
  {
    key: 'Q7',
    number: 7,
    question: 'What was your employment type?',
    type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
    options: ['Permanent', 'Contract', 'Trainee'],
    is_required: true,
  },
  {
    key: 'Q8',
    number: 8,
    question: 'What was the duration of your employment?',
    type: QUESTIONNAIRE_ANSWER_TYPES.DURATION,
    is_required: true,
  },
  {
    key: 'Q9',
    number: 9,
    question:
      'What was your average monthly income during the last 12 months?',
    type: QUESTIONNAIRE_ANSWER_TYPES.DROPDOWN,
    options: [
      '50K–100K',
      '100K–300K',
      '300K–500K',
      '500K–750K',
      '750K–1Mn',
      'Above 1Mn',
    ],
    is_required: true,
  },
  {
    key: 'Q10',
    number: 10,
    question: 'How frequently did you achieve your targets?',
    type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
    options: [
      'Consistently Achieved',
      'Occasionally Achieved',
      'Rarely Achieved',
    ],
    is_required: true,
  },
  {
    key: 'Q11',
    number: 11,
    question: 'What was your last drawn incentive amount?',
    type: QUESTIONNAIRE_ANSWER_TYPES.DROPDOWN,
    options: [
      'Below 50K',
      '50K–150K',
      '150K–250K',
      '250K–500K',
      'Above 500K',
    ],
    is_required: true,
  },
  {
    key: 'Q12',
    number: 12,
    question: 'What is your reason for seeking a new role?',
    type: QUESTIONNAIRE_ANSWER_TYPES.MULTI_SELECT,
    options: [
      'Career Growth',
      'Better Income',
      'Job Dissatisfaction',
      'Personal Reasons',
      'Other (Please Specify)',
    ],
    is_required: true,
  },
  {
    key: 'Q13',
    number: 13,
    question: 'How many years have you qualified for MDRT?',
    type: QUESTIONNAIRE_ANSWER_TYPES.NUMBER,
    placeholder: 'Enter number of years',
    is_required: true,
    min: 0,
    max:99,
    max_digits: 2,
  },
  {
    key: 'Q14',
    number: 14,
    question:
      'What type of performance measurement was used in your role?',
    type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
    options: ['Targets', 'KPIs', 'None'],
    is_required: true,
  },
  {
    key: 'Q15',
    number: 15,
    question: 'What are your career goals for the next 3 years?',
    type: QUESTIONNAIRE_ANSWER_TYPES.TEXTAREA,
    remarks:
      'Please specify your goals related to Income, Personal development & Education',
    is_required: true,
  },
  {
    key: 'Q16',
    number: 16,
    question:
      'How would you rate your current loan and expense commitments?',
    type: QUESTIONNAIRE_ANSWER_TYPES.DROPDOWN,
    options: ['Low', 'Medium', 'High', 'Very High'],
    is_required: true,
  },
  {
    key: 'Q17',
    number: 17,
    question:
      'What is the longest tenure you have spent in a single company?',
    type: QUESTIONNAIRE_ANSWER_TYPES.DROPDOWN,
    options: ['Less than 12 Months', '12–23 Months', '24 Months or More'],
    is_required: true,
  },
  {
    key: 'Q18',
    number: 18,
    question: 'Are you bringing an existing client base/book of business?',
    type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
    options: ['Yes', 'Partial', 'No'],
    is_required: true,
  },
  {
    key: 'Q19',
    number: 19,
    question:
      'Do you currently engage in any part-time role (Broker, Agency, Business, etc.)?',
    type: QUESTIONNAIRE_ANSWER_TYPES.BOOLEAN,
    is_required: true,
  },
  {
    key: 'Q20',
    number: 20,
    question: 'Are you an IBSL license holder?',
    type: QUESTIONNAIRE_ANSWER_TYPES.BOOLEAN,
    is_required: true,
  },
  {
    key: 'Q21',
    number: 21,
    question: 'Have you received Top Performer recognition?',
    type: QUESTIONNAIRE_ANSWER_TYPES.BOOLEAN,
    is_required: true,
  },
  {
    key: 'Q22',
    number: 22,
    question: 'What is your highest achievement level?',
    type: QUESTIONNAIRE_ANSWER_TYPES.DROPDOWN,
    options: ['Company Level', 'Regional Level', 'National Level', 'None'],
    is_required: true,
  },
  {
    key: 'Q23',
    number: 23,
    question: 'What is your promotion history?',
    type: QUESTIONNAIRE_ANSWER_TYPES.DROPDOWN,
    options: ['Promoted Multiple Times', 'Promoted Once', 'No Promotion'],
    is_required: true,
  },
  {
    key: 'Q24',
    number: 24,
    question: 'What is your estimated professional network size?',
    type: QUESTIONNAIRE_ANSWER_TYPES.DROPDOWN,
    options: ['Below 50', '50–100', '100–300', 'Above 300'],
    is_required: true,
  },
  {
    key: 'Q25',
    number: 25,
    question:
      'What is your level of involvement in community and social activities?',
    type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
    options: HIGH_MEDIUM_LOW,
    is_required: true,
  },
  {
    key: 'Q26',
    number: 26,
    question:
      'What is your ability and willingness to travel for field work?',
    type: QUESTIONNAIRE_ANSWER_TYPES.RADIO,
    options: HIGH_MEDIUM_LOW,
    is_required: true,
  },
];
